import {QueryReason} from 'common/report/util/query-tracking/types';
import {reporter} from 'common/report/error-reporting';

const QUERY_REASON_PRECEDENCE: QueryReason[] = [
  QueryReason.QbFilterUpdate,
  QueryReason.QbBreakdownUpdate,
  // Bookmark view should have higher precedence than non-specific query builder updates. Loading a bookmark can
  // cause "qb_auto_triggered" (and possibly "qb_other_update" if "qb_auto_triggered" are misclassified) query
  // builder updates (depending on implementation).
  QueryReason.BookmarkView,
  QueryReason.QbOtherUpdate,
  QueryReason.QbAutoTriggered,
  QueryReason.QbQTSUpdate,
];

if (QUERY_REASON_PRECEDENCE.length !== Object.values(QueryReason).length) {
  reporter.error(`All query reasons should be specified in QUERY_REASON_PRECEDENCE list`);
}

// Because of throttling, it's possible for there to be multiple pending query reasons before the next query.
// If this is the case, we pick the most important query reason as the reason for the query.
export function maxQueryReason(queryReasons: QueryReason[]) {
  return QUERY_REASON_PRECEDENCE.find((queryReason) => {
    return queryReasons.includes(queryReason);
  });
}
